<template>
  <div class="m-pc-comment" v-if="isAllowedComment">
    <div class="comment-header">
      <div class="comment-title">评论</div>
      <div class="comment-num">
        <span>{{ commentCount }}</span
        >条评论
      </div>
    </div>
    <div
      class="comment-content"
      :class="{ 'need-login': sess == '' && postIdentity == 3 }"
    >
      <textarea
        :disabled="sess == '' && postIdentity == 3"
        @focus="textFocus"
        @blur="textBlur"
        v-model="commentContent"
      >
      </textarea>
      <div class="comment-submit">
        <div
          class="comment-button"
          :class="{
            'not-allow':
              commentContent.length > 500 || commentContent.length == 0
          }"
          @click="createComment()"
        >
          <span class="icontemp fabu"></span>发布
        </div>
      </div>
      <div class="comment-login-tips" v-if="!sess && postIdentity == 3">
        去 <span class="comment-login" @click="goLogin()">登录</span>留言讨论吧
      </div>
      <div
        class="comment-login-tips"
        @click="checkTipe()"
        v-if="(sess || postIdentity != 3) && isShowTips && !commentContent"
      >
        欢迎留言讨论
      </div>
    </div>
  </div>
</template>
<script>
import { $subscriber, interact } from "fire-wind-water";
import { articleId } from "../common/sbase";
import service from "../services/article";
import $ from "jquery";
export default {
  name: "Comment",
  data() {
    return {
      // info:{},
      isAllowedComment: false,
      commentCount: 0,
      loginUrl: "",
      sess: "", //登录状态,
      postIdentity: "",
      isShowTips: true,
      commentContent: "",
      topicInfo: {},
      articleInfo: {},
      isSubmiting: false,
      userInfo: {}
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      // this.info = info;
      this.isAllowedComment = info.isAllowedComment == 1;
      this.articleInfo = info;
    });
    $subscriber.subscribe("comment-count", info => {
      // this.info = info;
      this.commentCount = info;
    });
    $subscriber.subscribe("user-info", info => {
      if (info) {
        this.userInfo = info;
      }
    });
    $subscriber.subscribe("topic-config", info => {
      //讨论区配置内容
      //判断登录状态
      this.topicInfo = info;
      this.postIdentity = info.postIdentity;
      this.sess = this.userInfo.session;
      console.log(this.userInfo, this.sess, this.userInfo.session);
      if (info.postIdentity == 3 && !this.sess) {
        //需要登录
        const param = {
          memberFormId: info.postIdentityExtra,
          formId: info.postIdentityExtra,
          globalUserId: this.userInfo.globalUserId,
          keyword: "",
          num: 999,
          schemaId: info.schemaId,
          start: 0,
          tenantId: info.tenantId,
          trackId: "0"
        };
        service.getNewForm(param).subscribe(data => {
          this.loginUrl = data.content.pcSourceUrl;
        });
      }
    });
  },
  methods: {
    goLogin() {
      const href = `${this.loginUrl}&backUrl=${encodeURIComponent(
        window.location.href
      )}`;
      window.$sk.goto(href);
    },
    textFocus() {
      this.isShowTips = false;
    },
    textBlur() {
      this.isShowTips = true;
    },
    createComment() {
      if (this.commentContent.length > 500 || this.commentContent.length == 0) {
        if (this.commentContent.length > 500) {
          window.$s_temp.alert("内容长度超出500字限制，请精简后提交！");
        }
        return;
      }
      if (this.isSubmiting) {
        return;
      }
      this.isSubmiting = true;
      // const globalUserId1 = ck.cookie("globalUserId")?ck.cookie("globalUserId").replace(/"/g, ""):'';
      let param = {
        topicId: this.articleInfo.topicId,
        tenantId: this.articleInfo.tenantId,
        nodeId: this.articleInfo.tenantId,
        moduleId: this.articleInfo.moduleId,
        instanceId: this.articleInfo.instanceId,
        isAnonymous: this.sess == "" ? 1 : 0,
        content: this.commentContent,
        commentId: 0,
        openId: this.userInfo.openId || "",
        cookieId: this.userInfo.globalUserId,
        globalUserId: this.userInfo.globalUserId,
        nickname: "",
        createrPic: "",
        createrLocation: "",
        subVersionId: articleId,
        sess: this.sess,
        title: this.articleInfo.title,
        weChatId: this.articleInfo.authorisedWeChatId,
        browseInfo: interact.browseInfo
      };
      service.createComment(param).subscribe(data => {
        if (data.result == 0) {
          this.commentContent = "";
          $subscriber.emit("get-comment-list");
          setTimeout(() => {
            this.isSubmiting = false;
          }, 500);
        } else {
          this.commentContent = "";
          this.isSubmiting = false;
        }
      });
    },
    checkTipe() {
      $("textarea").focus();
    }
  },
  components: {}
};
</script>
